/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemList
//   Details:    Item list compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC  M01  Added SimpleMode
// 113775 15/06/21 JC  M02JC	'state' passed into handleSelect was string but needed to be handled as boolean
// WI3713 24/01/24 JC  M03JC    Expanded documents for data forms
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import { bindActionCreators } from 'redux';//M03JC
import { connect } from 'react-redux';
import Header from '../components/Header';
import ItemsList from '../components/ItemsList';
import { itemActions } from '../store/Items';
import { redirectControllerActions } from '../store/RedirectController'; //M03JC

class ItemsPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			usePrevPageArgs: false, //M03JC
			showHistory: false,
			expandedItemId: 0 //M03JC
			//M03JC removed as unused //unread: 0
            //M03JC removed as unused //readPage: 0
		};

		this.handleSelect = this.handleSelect.bind(this);
	}

	//M03JC
	static getDerivedStateFromProps(props, state) {

		//only if we have a match
		if (props.match != undefined) {

			//get values from props
			let usePrevPageArgs = props.match.params.usePrevPageArgs;
			//interpret the value
			if (usePrevPageArgs != 1) { usePrevPageArgs = false } else { usePrevPageArgs = true };

			if (usePrevPageArgs !== state.usePrevPageArgs) {

				//get the previous page args
				let previousPageArgs = props.redirectController.previousPageArgs;
				//and if they exist retrieve the details
				if (previousPageArgs) {
					let showHistory = (previousPageArgs.showHistory != undefined ? previousPageArgs.showHistory : showHistory)
					let itemId = (previousPageArgs.itemId != undefined ? previousPageArgs.itemId: 0)

					//clear the history
					props.clearRedirect();

					//return new state
					return ({
						usePrevPageArgs: usePrevPageArgs,
						showHistory: showHistory,
						expandedItemId: itemId
					});
				}
			}
		}	

		// Return null to indicate no change to state.
		return null;
	}

	handleSelect(state) {

		 //M02JC convert tab text to boolean
		var bShowHistory = (state === 'true');

		this.setState({ showHistory: bShowHistory }); //M02JC
	}

	render() {
		return (
			<div>
                <Header title={this.props.title}>
                    {!this.props.simpleMode ?
                         /* M01 don't show the tabs if in all simple mode */
                        <Tabs
                            activeKey={this.state.showHistory} //M03JC fixed as there was no key
                            onSelect={this.handleSelect}
                            id="itemspage-tabcontrol"
                        >
                            <Tab eventKey={false} title={this.props.unreadTabText} />
                            <Tab eventKey={true} title={this.props.readTabText} />
                        </Tabs>
                        : []}
				</Header>

				{!this.state.showHistory ?
					<ItemsList
						itemCategory={this.props.unreadItemCategory}
						itemTypes={this.props.unreadItemTypes.items}
						itemTypeId={this.props.unread.itemTypeId}
						items={this.props.unread.items}
						maxPage={this.props.unread.maxPage}
						page={this.props.unread.page}
						message={this.props.unread.error}
						isLoading={this.props.unread.isLoading}

						showNewButton={this.props.showNewButton}
						newButtonText={this.props.newButtonText}
						onNewClick={this.props.onNewClick}
						simpleMode={this.props.simpleMode} // M01 pass simple mode to items list 
						showHistory={this.state.showHistory} //M03JC
						expandedItemId={this.state.expandedItemId} //M03JC
					/>
					: []}
			
				{this.state.showHistory ?
					<ItemsList
						itemCategory={this.props.readItemCategory}
						itemTypes={this.props.readItemTypes.items}
						itemTypeId={this.props.read.itemTypeId}
						items={this.props.read.items}
						maxPage={this.props.read.maxPage}
						page={this.props.read.page}
						message={this.props.read.error}
						isLoading={this.props.read.isLoading}

						showNewButton={this.props.showNewButton}
						newButtonText={this.props.newButtonText}
						onNewClick={this.props.onNewClick} // M01 pass simple mode to items list
						showHistory={this.state.showHistory} //M03JC
						expandedItemId={this.state.expandedItemId} //M03JC
					/>
					: []}
			</div>
		);
	}
}

ItemsPage.propTypes = {
	title: PropTypes.string.isRequired,

	unreadItemCategory: PropTypes.string,
	unreadItemTypes: PropTypes.any,
	unread: PropTypes.shape({
		items: PropTypes.arrayOf(PropTypes.any),
		pages: PropTypes.number,
		page: PropTypes.number,
		error: PropTypes.string,
		isLoading: PropTypes.bool
	}),

	readItemCategory: PropTypes.string,
	readItemTypes: PropTypes.any,
	read: PropTypes.shape({
		items: PropTypes.arrayOf(PropTypes.any),
		pages: PropTypes.number,
		page: PropTypes.number,
		error: PropTypes.string,
		isLoading: PropTypes.bool
	})
};

export default connect(
	state => state,
	dispatch => bindActionCreators({ ...itemActions, ...redirectControllerActions }, dispatch) //M03JC
)(ItemsPage);